import { type RouteDefinition } from "../../routes/routes";

import FetchTranscripts from "./FetchTranscripts";

export const TclipRoutes: RouteDefinition[] = [
    {

        path: "/tclip",
        layout: "/user",
        application: "Admin",
        children: [
            {
               path: "/user/tclip/transcripts",
               component: FetchTranscripts,
               exact: true,
             },
        ]
    }
];